import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import { Card, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router";
import { ContainerGrid, HeaderLayout } from "../../components";
import type React from "react";

interface IProps {
  children?: React.ReactNode;
  faded?: boolean;
  title?: string | React.ReactNode;
  actions?: React.ReactNode;
  sideBarContent?: React.ReactNode;
}

const DetailPageLayout = (props: IProps) => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <HeaderLayout
      title={
        <Stack direction="row" sx={{
          justifyContent: "space-between"
        }}>
          <Stack direction="row" spacing={1} sx={{
            alignItems: "center"
          }}>
            {window.history.length > 1 && (
              <IconButton variant="tertiary" onClick={() => navigate(-1)}>
                <ArrowBackIosNewRoundedIcon />
              </IconButton>
            )}

            {props.title &&
              (typeof props.title === "string" ? <Typography variant="h6">{props.title}</Typography> : props.title)}
          </Stack>

          {props.actions}
        </Stack>
      }
    >
      <ContainerGrid container spacing={1}>
        {props.sideBarContent && !props.faded && (
          <ContainerGrid size={{ xs: 12, md: 4 }}>{props.sideBarContent}</ContainerGrid>
        )}

        <ContainerGrid size={{ xs: 12, md: 8 }} offset={{ md: props.sideBarContent ? 0 : 2 }}>
          <Card sx={{ background: props.faded ? theme.palette.grey[100] : undefined }}>{props.children}</Card>
        </ContainerGrid>
      </ContainerGrid>
    </HeaderLayout>
  );
};

export { DetailPageLayout };
